import React from 'react';
import { Image } from 'react-native';
import { useThemeName } from '@tamagui/core';
import { XStack, YStack } from '@tamagui/stacks';
import { Wallet, Filter } from 'lucide-react-native';
import IconButton from './IconButton';
import { logo } from '@/assets';

type Props = {
  onPressLeft?: () => void;
  onPressRight?: () => void;
};

const Header: React.FC<Props> = ({ onPressLeft, onPressRight }) => {
  const themeName = useThemeName();
  const iconColor = themeName === 'dark' ? '#ffffff' : '#18181b';

  return (
    <YStack paddingHorizontal="$4" paddingVertical="$2">
      <XStack alignItems="center" justifyContent="space-between">
        <IconButton onPress={onPressLeft} accessibilityLabel="Open wallet">
          <Wallet size={28} color={iconColor} />
        </IconButton>
        <YStack flex={1} alignItems="center" justifyContent="center">
          <Image
            source={logo}
            style={{ width: 84, height: 50, resizeMode: 'contain' }}
          />
        </YStack>
        <IconButton onPress={onPressRight} accessibilityLabel="Open filters">
          <Filter size={28} color={iconColor} />
        </IconButton>
      </XStack>
    </YStack>
  );
};

export default Header;


